export default __webpack_public_path__ + "static/media/wowhead.f9dffa87.png";